import OrderQuery from './order'

const DeliveryQuery = {
  mealManagement: `id state forDeliveryAt orders { ${OrderQuery.mealManagement} }`,
}

export default DeliveryQuery
